<template>
  <div class="container-fluid customer-home-container">
    <b-alert show variant="doom-yoga" v-if="login_user == null">
      <h4 class="alert-heading">
        This is only available for do.om yoga members!
      </h4>
      <p>
        Join DO.OMYOGA to find peace in sound and silence through movement and
        deep listening meditation.
      </p>
    </b-alert>
    <!-- home img -->
    <b-row>
      <b-col lg="2" md="5" cols="5" class="mx-auto">
        <img
          class="mx-auto"
          id="doomYogaLoginImg"
          src="@/assets/images/doom-yoga/doom-yoga-login-image2.png"
          alt="doomyoga Logo"
        />
      </b-col>
    </b-row>
    <!-- welcome user -->
    <b-row>
      <b-col lg="6" class="mx-auto">
        <h2 class="welcomeUserHomeH2DY">Namaste {{ user_name }}</h2>
        <p class="welcomeUserHomePDY">What will bring you awareness today?</p>
      </b-col>
    </b-row>
    <!-- media images  -->
    <!-- movement-home-default , meditation-home-default , movement-home-hover.png, music-home-hover.png -->
    <b-row class="mb-4">
      <b-col lg="4" md="6" class="mediaImageHomeContainerDYDiv mb-4">
        <b-card
          class="mediaImageHomeDYCard m-0 mediaImageDefaultDiv"
          overlay
          :img-src="
            require('@/assets/images/doom-yoga/movement-home-default.png')
          "
          img-alt="Card Image"
          text-variant="white"
        >
          <b-card-text>Movement </b-card-text>
        </b-card>
        <b-card
          class="mediaImageHomeDYCard m-0 mediaImageHoverDiv"
          overlay
          :img-src="
            require('@/assets/images/doom-yoga/movement-home-hover.png')
          "
          img-alt="Card Image"
          text-variant="white"
          title="Movement"
        >
          <b-card-text>
            <span>Live Streams</span><span>Live Stream Playbacks</span>
            <span>On Demand Videos</span>
          </b-card-text>
          <router-link
            to="/doom_yoga/movement"
            class="btn btn-outline-home-doom-yoga"
            >Practice now</router-link
          >
          <!-- <button class="btn btn-outline-home-doom-yoga">Practice now</button> -->
        </b-card>
      </b-col>
      <b-col lg="4" md="6" class="mediaImageHomeContainerDYDiv mb-4">
        <b-card
          class="mediaImageHomeDYCard m-0 mediaImageDefaultDiv"
          overlay
          :img-src="
            require('@/assets/images/doom-yoga/meditation-home-default.png')
          "
          img-alt="Card Image"
          text-variant="white"
        >
          <b-card-text>Meditation </b-card-text>
        </b-card>
        <b-card
          class="mediaImageHomeDYCard m-0 mediaImageHoverDiv"
          overlay
          :img-src="
            require('@/assets/images/doom-yoga/meditation-home-hover.png')
          "
          img-alt="Card Image"
          text-variant="white"
          title="Meditation"
        >
          <b-card-text>
            <span>Breathe, watch and listen</span>
            <span>Guided meditation on demand</span>
          </b-card-text>
          <router-link
            to="/doom_yoga/meditation"
            class="btn btn-outline-home-doom-yoga"
            >Meditate now</router-link
          >
          <!-- <button class="btn btn-outline-home-doom-yoga">Meditate now</button> -->
        </b-card>
      </b-col>
      <b-col lg="4" md="6" class="mediaImageHomeContainerDYDiv mb-4">
        <b-card
          class="mediaImageHomeDYCard m-0 mediaImageDefaultDiv"
          overlay
          :img-src="require('@/assets/images/doom-yoga/music-home-default.png')"
          img-alt="Card Image"
          text-variant="white"
        >
          <b-card-text>Music </b-card-text>
        </b-card>
        <b-card
          class="mediaImageHomeDYCard m-0 mediaImageHoverDiv"
          overlay
          :img-src="require('@/assets/images/doom-yoga/music-home-hover.png')"
          img-alt="Card Image"
          text-variant="white"
          title="Music"
        >
          <b-card-text>
            <span>Nada yoga</span>
            <span>Music playlists exclusive music</span>
          </b-card-text>
           <router-link
            to="/doom_yoga/music"
            class="btn btn-outline-home-doom-yoga"
            >Listen now</router-link
          >
          <!-- <button class="btn btn-outline-home-doom-yoga">Listen now</button> -->
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "DoOmYogaCustomerHome",
  components: {},
  data() {
    return {
      login_user: window.localStorage.getItem("user"),
      user_name: "",
    };
  },
  mounted() {
    // console.log()
    // console.log(window.localStorage.getItem("user"))
    let user = window.localStorage.getItem("user");
    if (user != null) {
      let user_json = JSON.parse(user);
      //  console.log(user)
      this.user_name = user_json.name;
    }
  },
};
</script>

<style scoped::v-deep >
</style>


// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Home.vue